import { Button, HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useMapContext from 'components/Map/hooks/useMapContext';
import CloseIcon from 'components/icons/CloseIcon';

import useTranslation from './hooks/useTranslation';

import DrawControls from './components/DrawControls';
import DrawingModeDropdown from './components/DrawingModeDropdown';
import DrawingToolDropdown from './components/DrawingToolDropdown';
import MapError from './components/MapError';
import PointModeDropdown from './components/PointModeDropdown';
import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapHorizontalControlBar = ({
    className = '',
    onChangeDrawingMode,
    onChangeDrawingTool,
    onChangePointMode,
    onClickAddPoint,
    onClickClose,
    onClickCompleteDrawing,
    onClickRedo,
    onClickUndo,
    testId = TEST_ID
}: Props) => {
    const { mapState } = useMapContext();
    const { drawingMode, drawingTool, mapErrors, pointMode } = mapState;

    const { CLOSE, DRAW } = useTranslation();

    return (
        <HorizontalContainer className={className} testId={testId}>
            <Wrapper className={styles.controlsContainer}>
                {mapErrors.length > 0 && <MapError error={mapErrors[0]} />}

                <HorizontalContainer className={styles.buttonRow}>
                    <Wrapper className={styles.dropdownsRow}>
                        <Button className={`${styles.button} ${styles.drawButton}`}>
                            <Wrapper className={styles.drawButtonText}>{DRAW}</Wrapper>
                        </Button>

                        <PointModeDropdown
                            onPointModeChange={onChangePointMode}
                            pointMode={pointMode}
                        />

                        <DrawingModeDropdown
                            drawingMode={drawingMode}
                            onDrawingModeChange={onChangeDrawingMode}
                        />

                        <DrawingToolDropdown
                            drawingTool={drawingTool}
                            onDrawingToolChange={onChangeDrawingTool}
                        />
                    </Wrapper>

                    <Wrapper className={styles.actionsRow}>
                        <DrawControls
                            onClickAddPoint={onClickAddPoint}
                            onClickCompleteDrawing={onClickCompleteDrawing}
                            onClickRedo={onClickRedo}
                            onClickUndo={onClickUndo}
                        />

                        <Button
                            className={`${styles.button} ${styles.closeButton}`}
                            onClick={onClickClose}>
                            {CLOSE}

                            <CloseIcon className={styles.closeButtonIcon} />
                        </Button>
                    </Wrapper>
                </HorizontalContainer>
            </Wrapper>
        </HorizontalContainer>
    );
};

export default MapHorizontalControlBar;
